// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-forms-login-___styles__loginInputRow___1ZMT9{margin:15px auto;position:relative;width:100%}.src-forms-login-___styles__buttons___WZXh4{align-items:center;display:flex;flex-direction:column}.src-forms-login-___styles__buttons___WZXh4 .src-forms-login-___styles__loginButton___4HTEI{color:#fff;margin-bottom:24px;margin-top:32px;width:100%}.src-forms-login-___styles__storesCont___1dcLp{align-items:center;display:flex;justify-content:space-evenly;margin-bottom:24px;margin-top:24px}@media (max-width: 1024px) and (min-width: 600px){.src-forms-login-___styles__storesCont___1dcLp{justify-content:center;margin-bottom:8px;margin-top:8px}}@media (max-width: 600px){.src-forms-login-___styles__storesCont___1dcLp{justify-content:center;margin:0;margin-top:8px}}.src-forms-login-___styles__storesCont___1dcLp .src-forms-login-___styles__appStore___3vcCh{height:40px;width:109px}@media (max-width: 1024px) and (min-width: 600px){.src-forms-login-___styles__storesCont___1dcLp .src-forms-login-___styles__appStore___3vcCh{margin-right:24px}}@media (max-width: 600px){.src-forms-login-___styles__storesCont___1dcLp .src-forms-login-___styles__appStore___3vcCh{height:auto;margin-right:16px;width:70px}}@media (max-width: 600px){.src-forms-login-___styles__storesCont___1dcLp .src-forms-login-___styles__playStore___1K1lU{height:auto;width:90px}}\n", "",{"version":3,"sources":["webpack://src/forms/login/styles.scss"],"names":[],"mappings":"AAA2nC,kDAAe,gBAAgB,CAAC,iBAAiB,CAAC,UAAU,CAAC,4CAAS,kBAAkB,CAAC,YAAY,CAAC,qBAAqB,CAAC,4FAAsB,UAAU,CAAC,kBAAkB,CAAC,eAAe,CAAC,UAAU,CAAC,+CAAY,kBAAkB,CAAC,YAAY,CAAC,4BAA4B,CAAC,kBAAkB,CAAC,eAAe,CAAC,kDAAkD,+CAAY,sBAAsB,CAAC,iBAAiB,CAAC,cAAc,CAAC,CAAC,0BAA0B,+CAAY,sBAAsB,CAAC,QAAQ,CAAC,cAAc,CAAC,CAAC,4FAAsB,WAAW,CAAC,WAAW,CAAC,kDAAkD,4FAAsB,iBAAiB,CAAC,CAAC,0BAA0B,4FAAsB,WAAW,CAAC,iBAAiB,CAAC,UAAU,CAAC,CAAC,0BAA0B,6FAAuB,WAAW,CAAC,UAAU,CAAC","sourcesContent":[":export{backgroundGrey:#fafafa;black:#1e2520;blue:#1c5898;boxShadowGrey:rgba(11,9,44,0.2);btnActive:#48813c;btnDefault:#5ca44c;btnDisabled:#d0d0d0;btnGhostActive:rgba(92,164,76,0.25);btnGhostDefault:rgba(0,0,0,0);btnGhostHover:rgba(92,164,76,0.1);btnHover:#529244;btnSecondaryActive:#eaa43b;btnSecondaryDefault:#eaa43b;btnSecondaryDisabled:secondary;btnSecondaryHover:#eaa43b;btnTertiary:rgba(68,69,69,0.75);darkGrey:#737474;errorColor:#cd1515;faintBlue:rgba(28,88,152,0.05);green:#59bf28;grey:#d0d0d0;lightBlue:#2fb4f9;lightGrey:#f1f1f1;olive:#20cb9a;orange:#fe7a24;peach:#fdc;primary:#5ca44c;primary01:rgba(92,164,76,0.1);primaryHover:#529244;red:#fa1931;secondary:#eaa43b;secondary005:rgba(249,183,39,0.05);secondary01:rgba(234,164,59,0.1);success:#5ca44c;tertiary:rgba(68,69,69,0.75);transparent:rgba(0,0,0,0);warning:#ee7b23;white:#fff}:export{inputHeight:38px;l:24px;lFont:18px;m:20px;mFont:16px;mobileBreakpoint:600px;s:16px;sFont:14px;slimButtonHeight:24px;smallestSpacer:5px;spacer:15px;tablet:1024px;xl:28px;xlFont:20px;xs:12px;xsFont:12px;xxl:32px;xxlFont:24px;xxs:8px;xxsFont:10px;xxxl:40px;xxxlFont:28px;xxxs:4px;xxxxl:64px;xxxxs:2px}.loginInputRow{margin:15px auto;position:relative;width:100%}.buttons{align-items:center;display:flex;flex-direction:column}.buttons .loginButton{color:#fff;margin-bottom:24px;margin-top:32px;width:100%}.storesCont{align-items:center;display:flex;justify-content:space-evenly;margin-bottom:24px;margin-top:24px}@media (max-width: 1024px) and (min-width: 600px){.storesCont{justify-content:center;margin-bottom:8px;margin-top:8px}}@media (max-width: 600px){.storesCont{justify-content:center;margin:0;margin-top:8px}}.storesCont .appStore{height:40px;width:109px}@media (max-width: 1024px) and (min-width: 600px){.storesCont .appStore{margin-right:24px}}@media (max-width: 600px){.storesCont .appStore{height:auto;margin-right:16px;width:70px}}@media (max-width: 600px){.storesCont .playStore{height:auto;width:90px}}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundGrey": "#fafafa",
	"black": "#1e2520",
	"blue": "#1c5898",
	"boxShadowGrey": "rgba(11,9,44,0.2)",
	"btnActive": "#48813c",
	"btnDefault": "#5ca44c",
	"btnDisabled": "#d0d0d0",
	"btnGhostActive": "rgba(92,164,76,0.25)",
	"btnGhostDefault": "rgba(0,0,0,0)",
	"btnGhostHover": "rgba(92,164,76,0.1)",
	"btnHover": "#529244",
	"btnSecondaryActive": "#eaa43b",
	"btnSecondaryDefault": "#eaa43b",
	"btnSecondaryDisabled": "secondary",
	"btnSecondaryHover": "#eaa43b",
	"btnTertiary": "rgba(68,69,69,0.75)",
	"darkGrey": "#737474",
	"errorColor": "#cd1515",
	"faintBlue": "rgba(28,88,152,0.05)",
	"green": "#59bf28",
	"grey": "#d0d0d0",
	"lightBlue": "#2fb4f9",
	"lightGrey": "#f1f1f1",
	"olive": "#20cb9a",
	"orange": "#fe7a24",
	"peach": "#fdc",
	"primary": "#5ca44c",
	"primary01": "rgba(92,164,76,0.1)",
	"primaryHover": "#529244",
	"red": "#fa1931",
	"secondary": "#eaa43b",
	"secondary005": "rgba(249,183,39,0.05)",
	"secondary01": "rgba(234,164,59,0.1)",
	"success": "#5ca44c",
	"tertiary": "rgba(68,69,69,0.75)",
	"transparent": "rgba(0,0,0,0)",
	"warning": "#ee7b23",
	"white": "#fff",
	"inputHeight": "38px",
	"l": "24px",
	"lFont": "18px",
	"m": "20px",
	"mFont": "16px",
	"mobileBreakpoint": "600px",
	"s": "16px",
	"sFont": "14px",
	"slimButtonHeight": "24px",
	"smallestSpacer": "5px",
	"spacer": "15px",
	"tablet": "1024px",
	"xl": "28px",
	"xlFont": "20px",
	"xs": "12px",
	"xsFont": "12px",
	"xxl": "32px",
	"xxlFont": "24px",
	"xxs": "8px",
	"xxsFont": "10px",
	"xxxl": "40px",
	"xxxlFont": "28px",
	"xxxs": "4px",
	"xxxxl": "64px",
	"xxxxs": "2px",
	"loginInputRow": "src-forms-login-___styles__loginInputRow___1ZMT9",
	"buttons": "src-forms-login-___styles__buttons___WZXh4",
	"loginButton": "src-forms-login-___styles__loginButton___4HTEI",
	"storesCont": "src-forms-login-___styles__storesCont___1dcLp",
	"appStore": "src-forms-login-___styles__appStore___3vcCh",
	"playStore": "src-forms-login-___styles__playStore___1K1lU"
};
export default ___CSS_LOADER_EXPORT___;
